<script>import { createEventDispatcher, getContext } from "svelte";
import { detectTypingStopped } from "../../../actions/typingStopped.js";
import { formReset } from "../../../actions/formReset.js";
export let showPassword = false;
export let showLast = true;
export let contextKey;
const ctx = getContext(contextKey);
let { name, empty, dirty, focus, visited, disabled, value } = ctx;
let initialValue = $value;
let state = {
  empty: $empty,
  dirty: $dirty,
  focus: $focus,
  visited: $visited,
  disabled: $disabled
};
const dispatch = createEventDispatcher();
const checkForValueChanges = (value2) => {
  if ((value2 ? value2.length : 0) != (displayValue ? displayValue.length : 0)) {
    displayValue = getDisplayValue(showPassword);
  }
};
$: {
  checkForValueChanges($value);
  $empty = $value === void 0;
  $dirty = !$disabled ? ($value !== void 0 || !initialValue != void 0) && $value !== initialValue : false;
  $focus = !$disabled ? $focus : false;
  $visited = !$disabled ? $visited : false;
  let changes = {};
  if ($empty != state.empty) {
    changes.empty = $empty;
  }
  if ($dirty != state.dirty) {
    changes.dirty = $dirty;
  }
  if ($focus != state.focus) {
    changes.focus = $focus;
  }
  if ($visited != state.visited) {
    changes.visited = $visited;
  }
  state = { empty: $empty, dirty: $dirty, focus: $focus, visited: $visited, disabled: $disabled };
  if (Object.keys(changes).length > 0) {
    dispatch("state", { changes, state });
  }
}
let debounceTime = 1e3;
const hideChar = "\u25CF";
const matcher = new RegExp(`^[${hideChar}]*(.*?)[${hideChar}]*$`, "g");
const getHidden = (n) => new Array(n + 1).join(hideChar);
const getDisplayValue = (showPassword2) => $value ? showPassword2 ? $value : getHidden($value.length) : "";
const updateShowPassword = (showLast2, displayValue2, value2) => {
  const result = { displayValue: displayValue2, value: value2 };
  if (!displayValue2) {
    result.displayValue = "";
    result.value = "";
  } else {
    result.value = displayValue2;
  }
  return result;
};
const updateHidePassword = (showLast2, displayValue2, value2) => {
  const result = { displayValue: displayValue2, value: value2 };
  if (!displayValue2) {
    result.displayValue = "";
    result.value = "";
  } else {
    let match = displayValue2 ? matcher.exec(displayValue2) : null;
    matcher.lastIndex = 0;
    if (match) {
      if (match[0] === match[1]) {
        result.value = displayValue2;
        if (displayValue2.length > 0) {
          result.displayValue = getHidden(displayValue2.length);
        }
      } else {
        let deltaLength = displayValue2.length - value2.length;
        if (deltaLength < 0) {
          result.value = value2.substring(0, displayValue2.length);
          result.displayValue = getHidden(displayValue2.length);
        } else if (deltaLength > 0) {
          result.value = value2 + match[1].substring(match[1].length - deltaLength);
          result.displayValue = showLast2 ? getHidden(displayValue2.length - 1) + match[1].charAt(match[1].length - 1) : getHidden(displayValue2.length);
        }
      }
    }
  }
  return result;
};
const typingStopped = () => {
  displayValue = getDisplayValue(showPassword);
};
let updater = showPassword ? updateShowPassword : updateHidePassword;
let displayValue = getDisplayValue(showPassword);
$: {
  updater = showPassword ? updateShowPassword : updateHidePassword;
  displayValue = getDisplayValue(showPassword);
}
const onHiddenInputEvent = (ev) => {
  const elem = ev.target ? ev.target : void 0;
  if (elem) {
    displayValue = getDisplayValue(showPassword);
    if (!$empty || !!$value) {
      dispatch("changed", {
        name,
        value: $value
      });
    }
  } else {
  }
};
const onDisplayInputEvent = (ev) => {
  const elem = ev.target ? ev.target : void 0;
  if (elem) {
    const updates = updater(showLast, displayValue, $value ?? "");
    displayValue = updates.displayValue;
    $value = updates.value;
    dispatch("changed", {
      name,
      value: $value
    });
  } else {
  }
};
</script>

<input
	{name}
	use:formReset
	style="display:none;"
	type="text"
	bind:value={$value}
	on:input={onHiddenInputEvent}
/>
<input
	use:detectTypingStopped={debounceTime}
	on:typingStopped={typingStopped}
	type="text"
	autocomplete="off"
	bind:value={displayValue}
	disabled={$disabled}
	on:focus={() => {
		$visited = true;
		$focus = true;
	}}
	on:blur={() => {
		$focus = false;
	}}
	on:copy={(ev) => {
		if (ev.clipboardData) {
			ev.clipboardData.setData('text/plain', $value ? $value : '');
			ev.preventDefault();
		}
	}}
	on:input={onDisplayInputEvent}
/>
